export type DocumentPageFormat = 'card' | 'passport' | 'document';
